
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2BGrid extends Serenity.EntityGrid<B2BRow, any> {
        protected getColumnsKey() { return B2BColumns.columnsKey; }
        protected getDialogType() { return B2BDialog; }
        protected getIdProperty() { return B2BRow.idProperty; }
        protected getInsertPermission() { return B2BRow.insertPermission; }
        protected getLocalTextPrefix() { return B2BRow.localTextPrefix; }
        protected getService() { return B2BService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: B2BService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}